<!-- ── Dialog Header ───────────────────────────────────────── -->
<div class="dlp-header" mat-dialog-title>
  <div class="dlp-header-icon-wrap">
    <ion-icon name="share-social-outline"></ion-icon>
  </div>
  <div class="dlp-header-text">
    <span class="dlp-header-title">Share {{ entityType }} Link</span>
    <span class="dlp-header-subtitle">Send this link to anyone</span>
  </div>
  <button class="dlp-close-btn" mat-icon-button (click)="close()" aria-label="Close dialog">
    <ion-icon name="close-outline"></ion-icon>
  </button>
</div>

<!-- ── Dialog Content ─────────────────────────────────────── -->
<mat-dialog-content class="dlp-content">

  <!-- Instruction Row -->
  <div class="dlp-info-row">
    <div class="dlp-info-icon-box">
      <ion-icon name="home-outline"></ion-icon>
    </div>
    <div>
      <span class="dlp-info-label">{{ entityType }} Detail Page</span>
      <span class="dlp-info-caption">Copy or open the link below to access full {{ entityType | lowercase }} information.</span>
    </div>
  </div>

  <!-- URL Card -->
  <ion-card class="dlp-url-card">
    <ion-card-content class="dlp-url-card-content">
      <div class="dlp-url-icon-col">
        <ion-icon name="link-outline"></ion-icon>
      </div>
      <a [href]="data.url" target="_blank" class="dlp-url-text" rel="noopener noreferrer">{{ data.linkLabel || data.url }}</a>
      <button class="dlp-open-btn" mat-icon-button [matTooltip]="'Open in new tab'" (click)="$event.stopPropagation()">
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" aria-label="Open link in new tab">
          <ion-icon name="open-outline"></ion-icon>
        </a>
      </button>
    </ion-card-content>
  </ion-card>

  <!-- Tip Row -->
  <div class="dlp-tip-row">
    <ion-icon name="information-circle-outline"></ion-icon>
    <span>Anyone with this link can view the {{ entityType | lowercase }} details page.</span>
  </div>

</mat-dialog-content>

<!-- ── Dialog Actions ─────────────────────────────────────── -->
<mat-dialog-actions class="dlp-actions">
  <ion-button class="dlp-btn dlp-btn--secondary" fill="outline" (click)="close()">
    <ion-icon slot="start" name="close-circle-outline"></ion-icon>
    Close
  </ion-button>
  <ion-button class="dlp-btn dlp-btn--primary" (click)="copyUrl()">
    <ion-icon slot="start" [name]="copied ? 'checkmark-circle-outline' : 'copy-outline'"></ion-icon>
    {{ copied ? 'Copied!' : 'Copy Link' }}
  </ion-button>
</mat-dialog-actions>
